export default __webpack_public_path__ + "static/media/filtro.204491fc.png";